<div class="kf-editable-field">
    <div class="d-flex
         {{'kf-field-xs-' + labelCols}}
         {{'kf-field-sm-' + labelColsSm}}
         {{'kf-field-md-' + labelColsMd}}
         {{'kf-field-lg-' + labelColsLg}}
         {{'kf-field-xl-' + labelColsXl}}
         {{'kf-field-xxl-' + labelColsXxl}}">
        <div class="kf-input-label">
            <label for="{{id}}" (click)="$event.preventDefault()">
                {{label}}
                @if (helpText) {
                    <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                        <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                    </span>
                }
            </label>
        </div>
        <div class="kf-input col">
            <input #fileInput
                   type="file"
                   (change)="selectFile()"
                   [id]="id"
                   [name]="id"
                   [accept]="accept"
                   class="d-none"
                   [disabled]="!(isEditable$ | async)" />
            
            <div class="d-inline-flex" (click)="fileInput.click()">
                <button type="button" class="kf-btn kf-btn-light-gray kf-btn-xs py-0 me-1" [class.d-none]="!(isEditable$ | async)" (click)="null">{{obj[prop]?.name ? 'Replace' : 'Choose'}} File</button>
                <div class="kf-element btn-file-name"
                     [class.kf-cursor-default]="!(isEditable$ | async)"
                     [title]="obj[prop]?.name ?? ''">
                    {{displayName}}<span class="sr-only">{{obj[prop]?.name ?? ''}}</span>
                </div>
            </div>
            
            @if (obj[prop]?.name) {
                <!--  Can only remove a file if one is selected, the request is editable, and the feature is allowed.  -->
                @if ((isEditable$ | async) && canDelete) {
                    <button class="kf-btn kf-btn-blue kf-btn-xs ms-1 mb-1"
                            type="button"
                            (click)="removeFile()"
                            title="Remove">
                        <i class="fas fa-trash-alt">
                            <span class="sr-only">Click to remove file.</span>
                        </i>
                    </button>
                }
                <!--  Can only download file if it's been uploaded.  To enable this a function for downloading must be appended into the "download()"
                field for this object.  See hrpm-files.component.ts for an example.  -->
                @if (obj[prop]?.download) {
                    <button class="kf-btn-xs kf-btn kf-btn-blue ms-1 mb-1"
                            type="button"
                            (click)="obj[prop].download()"
                            title="Download">
                        <i class="fa-solid fa-file-arrow-down">
                            <span class="sr-only">Click to download file.</span>
                        </i>
                    </button>
                }
                <!--  Supplemental file infos have an EntryDate property.  If this date is appended into the "uploaded" field for this
                object we can display that date as the uploaded date in the UI.  See hrpm-files.component.ts for an example.  -->
                @if (obj[prop]?.uploaded) {
                    <div class="small fst-italic text-end">Uploaded: {{obj[prop]?.uploaded | date:'medium'}}</div>
                }
            }
        </div>
    </div>
    <!--  Errors/Warnings  -->
    @if ((isEditable$ | async)) {
        <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true"></observable-errors-warnings>
    }
</div>
